document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('[data-gallery]');
  if (!gallery) return;

  const slider = gallery.querySelector('.css-slider');
  const dots = gallery.querySelectorAll('.slider-dots button');
  const prevBtn = gallery.querySelector('.slider-arrow--prev');
  const nextBtn = gallery.querySelector('.slider-arrow--next');

  let currentIndex = 0;
  const totalSlides = dots.length;

  gallery.classList.add('is-ready');
  dots[0]?.classList.add('is-active');

  function goToSlide(index) {
    slider.scrollTo({
      left: slider.clientWidth * index,
      behavior: 'smooth'
    });

    dots.forEach(d => d.classList.remove('is-active'));
    dots[index]?.classList.add('is-active');

    currentIndex = index;
  }

  // DOTS
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      goToSlide(parseInt(dot.dataset.index));
    });
  });

  // LOOPING PREV
  prevBtn?.addEventListener('click', () => {
    const newIndex = currentIndex === 0
      ? totalSlides - 1
      : currentIndex - 1;

    goToSlide(newIndex);
  });

  // LOOPING NEXT
  nextBtn?.addEventListener('click', () => {
    const newIndex = currentIndex === totalSlides - 1
      ? 0
      : currentIndex + 1;

    goToSlide(newIndex);
  });
});
